import reducer from './reducer';

export { default as resultsActions } from './actions';
export { default as resultsSelectors } from './selectors';

export default reducer;
